
// Redux Form
import { SubmissionError } from 'redux-form';

// Language
import messages from '../../../locale/messages';

// Redirection
import history from '../../../history';

// Fetch request
import fetch from 'node-fetch';

// Redux
import { setRuntimeVariable } from '../../../actions/runtime';
import { setLoaderStart, setLoaderComplete } from '../../../actions/loader/loader';
import { getAdminUser } from '../../../actions/siteadmin/AdminUser/manageAdminUser';
import { getPrivileges } from '../../../actions/siteadmin/AdminRoles/manageAdminRoles';

async function submit(values, dispatch) {

  const query = `query (
    $email: String!,
    $password: String!) {
    adminUserLogin (
        email: $email,
        password: $password
    ) {
        status
        token
        errorType
        errorMessage
        isSuperAdmin
    }
}`;

  const variables = {
    email: values.email,
    password: values.password,
  };

  dispatch(setLoaderStart('AdminLogin'));

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query,
      variables
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  dispatch(setLoaderComplete('AdminLogin'));

  if (data.adminUserLogin.status == 200) {
    dispatch(setRuntimeVariable({
      name: 'isAdminAuthenticated',
      value: true,
    }));

    dispatch(setRuntimeVariable({
      name: 'isSuperAdmin',
      value: data && data.adminUserLogin && data.adminUserLogin.isSuperAdmin
    }));

    dispatch(getPrivileges());
    dispatch(getAdminUser());
    history.push('/siteadmin');
  } else if (data.adminUserLogin.status != 200 & data.adminUserLogin.errorType == "email") {
    throw new SubmissionError({ _error: messages.emailNotExists });
  } else if (data.adminUserLogin.status != 200 & data.adminUserLogin.errorType == "password") {
    throw new SubmissionError({ _error: messages.passwordWrong });
  } else if (data.adminUserLogin.status != 200 & data.adminUserLogin.errorType == "restaurantLoggedIn") {
    throw new SubmissionError({ _error: messages.restaurantLoggedIn });
  } else if (data.adminUserLogin.errorType == "adminLoggedIn") {
    dispatch(setRuntimeVariable({
      name: 'isAdminAuthenticated',
      value: true,
    }));

    dispatch(setRuntimeVariable({
      name: 'isSuperAdmin',
      value: data && data.adminUserLogin && data.adminUserLogin.isSuperAdmin
    }));
    
    dispatch(getPrivileges());
    dispatch(getAdminUser());
    throw new SubmissionError({ _error: messages.adminLoggedIn });
  } else {
    throw new SubmissionError({ _error: messages.somethingWentWrong });
  }

}

export default submit;
